// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/activity/group_preferences.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_common } from "../../core/common_pb";

/**
 * Describes the file proto/model/booking/activity/group_preferences.proto.
 */
export const file_proto_model_booking_activity_group_preferences = /*@__PURE__*/
  fileDesc("CjRwcm90by9tb2RlbC9ib29raW5nL2FjdGl2aXR5L2dyb3VwX3ByZWZlcmVuY2VzLnByb3RvEgZjYXJtZW4i9gEKEEdyb3VwUHJlZmVyZW5jZXMSLwoUcHJlZmVycmVkX3BhcnR5X3NpemUYASABKAsyES5jYXJtZW4uUGFydHlTaXplEjcKFXByZWZlcnJlZF9ncm91cF90eXBlcxgCIAMoDjIYLmNhcm1lbi5Hcm91cENvbXBvc2l0aW9uEiEKGXByZWZlcnJlZF9ndWlkZV9sYW5ndWFnZXMYAyADKAkSNQoScHJpdmFjeV9wcmVmZXJlbmNlGAQgASgOMhkuY2FybWVuLlByaXZhY3lQcmVmZXJlbmNlEh4KFnJlcXVpcmVkX2dyb3VwX21lbWJlcnMYBSADKAkq4wEKEEdyb3VwQ29tcG9zaXRpb24SIQodR1JPVVBfQ09NUE9TSVRJT05fVU5TUEVDSUZJRUQQABIhCh1HUk9VUF9DT01QT1NJVElPTl9BRFVMVFNfT05MWRABEiUKIUdST1VQX0NPTVBPU0lUSU9OX0ZBTUlMWV9GUklFTkRMWRACEh0KGUdST1VQX0NPTVBPU0lUSU9OX1NFTklPUlMQAxIiCh5HUk9VUF9DT01QT1NJVElPTl9ZT1VOR19BRFVMVFMQBBIfChtHUk9VUF9DT01QT1NJVElPTl9NSVhFRF9BR0UQBSqmAQoRUHJpdmFjeVByZWZlcmVuY2USIgoeUFJJVkFDWV9QUkVGRVJFTkNFX1VOU1BFQ0lGSUVEEAASJAogUFJJVkFDWV9QUkVGRVJFTkNFX1BSSVZBVEVfR1JPVVAQARIhCh1QUklWQUNZX1BSRUZFUkVOQ0VfSk9JTl9HUk9VUBACEiQKIFBSSVZBQ1lfUFJFRkVSRU5DRV9OT19QUkVGRVJFTkNFEANCMFouZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWwvYm9va2luZ2IGcHJvdG8z", [file_proto_model_core_common]);

/**
 * Describes the message carmen.GroupPreferences.
 * Use `create(GroupPreferencesSchema)` to create a new message.
 */
export const GroupPreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_group_preferences, 0);

/**
 * Describes the enum carmen.GroupComposition.
 */
export const GroupCompositionSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_activity_group_preferences, 0);

/**
 * @generated from enum carmen.GroupComposition
 */
export const GroupComposition = /*@__PURE__*/
  tsEnum(GroupCompositionSchema);

/**
 * Describes the enum carmen.PrivacyPreference.
 */
export const PrivacyPreferenceSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_activity_group_preferences, 1);

/**
 * @generated from enum carmen.PrivacyPreference
 */
export const PrivacyPreference = /*@__PURE__*/
  tsEnum(PrivacyPreferenceSchema);

